import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 10,
    color: "#fff",
  },
  ctn_loader: {
    display: "flex",
    position: "relative",
    width: 90,
    height: 90,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 100,
    background: "#ffffff78",
    padding: 8,
  },
  progress: {
    position: "absolute",
    "& .MuiCircularProgress-circle": {
      stroke: "url(#gradient)",
      strokeLinecap: "round",
    },
  },
  gradient: {
    "& stop:nth-child(1)": {
      stopColor: theme.palette.primary.main,
    },
    "& stop:nth-child(2)": {
      stopColor: theme.palette.secondary.main,
    },
  },
}));
// export default function Loader(props) {
//   const classes = useStyles();
//   return(
//     <Backdrop className={classes.backdrop} open={props.loading}>
//         <img src="../../spinner-unio.gif" alt="spinner" width="100px" height="100px" style={{ zIndex: 10 }} />
//     </Backdrop>
//   );
// }

export default function Loader(props) {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={props.loading}>
      <LoaderIcon />
    </Backdrop>
  );
}

export function LoaderIcon() {
  const classes = useStyles();
  return (
    <Box className={classes.ctn_loader}>
      <svg width="0" height="0">
        <defs>
          <linearGradient
            id="gradient"
            x1="1"
            y1="0"
            x2="0"
            y2="1"
            className={classes.gradient}
          >
            <stop offset="0%" />
            <stop offset="100%" />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress size={100} className={classes.progress} thickness={4} />
      <CircularProgress size={68} className={classes.progress} thickness={6} />
    </Box>
  );
}
